export const ETxnSpeed = {
  FOUR_DAY: "four_day",
  ONE_DAY: "one_day",
  ONE_DAY_NO_RESERVE: "one_day_no_reserve",
  TWO_DAY: "two_day",
  ZERO_DAY: "zero_day",
  ZERO_DAY_NO_RESERVE: "zero_day_no_reserve",
} as const;
export type ETxnSpeed = (typeof ETxnSpeed)[keyof typeof ETxnSpeed];
